
export default {
  list: [],
  createRecordExam: null
}



// WEBPACK FOOTER //
// ./src/store/modules/examination-report/state.js